import { render } from "./email_icon.vue?vue&type=template&id=356ddcd0&scoped=true"
import script from "./email_icon.vue?vue&type=script&lang=js"
export * from "./email_icon.vue?vue&type=script&lang=js"

import "./email_icon.vue?vue&type=style&index=0&id=356ddcd0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356ddcd0"]])

export default __exports__